function regulationSelectDirective() {
	var vm = {};

	vm.scope = {
		regulation : '=',
		onSelectRegulation : '&?',
		regulationsSelected : '=?',
		disabledModel : '=?disabled',
		filter : '=?' // filtros adicionales para la búsqueda
	};

	vm.restrict = 'E';

	vm.templateUrl = function(elem, attr) {
		return 'views/directives/regulationSelectDirective.html';
	};

	vm.controller = [ '$scope', '$window', 'alertService', 'regulationService', function($scope, $window, alertService, regulationService) {
		var vm = this;
		vm.loadInitData = false;
		$scope.availableRegulations = [];
		$scope.removedRegulations = [];
		$scope.disabled = false;

		if (!angular.isUndefined($scope.disabledModel) && $scope.disabledModel)
			$scope.disabled = true;

		$scope.searchRegulation = function(query) {
			if ($scope.regulationsCount && $scope.regulationsLimit) {
				if ($scope.regulationsCount <= $scope.regulationsLimit)
					return;
			}
			var filter = {};
			if ($scope.filter) {
				filter = $scope.filter;
			}
			if (query && query !== '') {
				filter['name'] = query;
			}
			if ($scope.regulationsSelected && $scope.regulationsSelected.length > 0) {
				var ni = $scope.regulationsSelected.map(function(sa) {
					return sa.id
				});
				filter['notin'] = ni;
			}
			$scope.loading = true;
			regulationService.searchRegulations(filter).then(function(response) {
				var resp = response.getData();
				$scope.availableRegulations = resp.results;

				if (!$scope.regulationsCount)
					$scope.regulationsCount = resp.totalRegisters;
				$scope.regulationsLimit = resp.limit;

				// si se cargaron datos selecionados mientras se
				// estaba leyendo los datos del servidor
				if (vm.loadInitData && $scope.regulationsSelected) {
					vm.loadInitData = false;
					$scope.regulationsSelected.forEach(function(sa) {
						removeFromAvailable(sa);
					});
				}
				$scope.loading = false;
			}, function(response) {
				// on error
				$scope.loading = false;
			});
		};

		$scope.onRegulationSelectChanged = function(regulation) {
			if ($scope.onSelectRegulation != undefined) {
				$scope.onSelectRegulation({
					regulation : regulation
				});
			}
		}

		// lo elimina de los posibles regulacioness
		$scope.removeFromAvailable = function(sa) {
			var index = $scope.availableRegulations.findIndex(function(am) {
				return am.id === sa.id
			});
			if (index >= 0) {
				$scope.removedRegulations.push($scope.availableRegulations[index]);
				$scope.availableRegulations.splice(index, 1);
			}
		};

		/*
		 * Verifica si alguna prueba que ya haya sido eliminada de las diponibles
		 * se elimino de las selecionadas y puyede volver a estar disponible
		 */
		$scope.lookForAvailable = function() {

			for (i = 0; i < $scope.removedRegulations.length; i++) {
				var s = $scope.removedRegulations[i];
				var reg = $scope.regulationsSelected.some(function(rs) {
					return rs.id == s.id;
				});
				if (reg)
					continue;
				$scope.availableRegulations.push(s);
				$scope.removedRegulations.splice(i, 1);
				i--;
			}

		}

	} ];

	vm.link = function(scope, element, attrs) {
		/*
		 * cambio el parametro y hay que sehabilitar el componente
		 */
		scope.$watch('disabledModel', function(newValue, oldValue) {
			if (!angular.isUndefined(newValue) && typeof (newValue) === "boolean")
				scope.disabled = newValue;
		});

		/*
		 * si se modifican las normativas selecionadas, se eliminan de las disponibles
		 */
		scope.$watch('regulationsSelected', function(newValue, oldValue) {
			if (!angular.isUndefined(newValue) && Array.isArray(newValue)) {
				newValue.forEach(function(r) {
					scope.removeFromAvailable(r);
				});
				scope.lookForAvailable();
			}
		});
	}

	return vm;
};

module.directive('regulationSelect', [ regulationSelectDirective ]);
